import {
  publicHttpClient,
  type AxiosRequestConfig,
} from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type { Tag } from './ahafood/get-deal-fn';
import type { NearestBranch, Rating } from './ahafood/get-store-fn';
import { apiRoutes } from './api-routes';
import { publicEnv } from '@/config/public-env.config.mjs';

export interface GetPersonalizeParams {
  customer_id: string;
  city_id: string;
  lat: number;
  lng: number;
  limit: number;
}

export interface PersonalizeResponse {
  debug: Debug;
  items: Item[];
}

export interface Debug {
  discount_preference: boolean;
  price_preference: any;
  categories_preference: string[];
  strategy: string;
  deduplication_stats: any;
  top_categories: string[];
  number_of_order: number;
  is_discount_lover: boolean;
  total_processing_time: number;
  has_purchase_history: boolean;
  is_new_user: boolean;
}
export interface Item {
  _id: number;
  name: string;
  tags: Tag[];
  price: number;
  store_id: number;
  discount_price?: number;
  distance: number;
  hybrid_score: number;
  image_thumb_url: string;
  status: string;
  extra_tags: any[];
  description: string;
  page_name: string;
  slug?: string;
  page_id: number;
  total_sold: number;
  rating: Rating;
  nearest_branch: NearestBranch;
  eta: number;
  trend_item: boolean;
  is_ai_image?: boolean;
}

export const getPersonalizeFn = async (
  params: GetPersonalizeParams,
  config: AxiosRequestConfig = {}
): Promise<PersonalizeResponse> => {
  const url =
    publicEnv.NEXT_PUBLIC_APP_FOOD_API_URI +
    apiRoutes.ahafood.store.get_personalize;
  const response = await publicHttpClient.get<PersonalizeResponse>(url, {
    params,
    ...config,
  });

  return response?.data;
};

export const useGetPersonalize = (
  params: GetPersonalizeParams,
  opts?: Omit<
    UseQueryOptions<PersonalizeResponse, Error>,
    'queryKey' | 'queryFn'
  >
) => {
  return useQuery<PersonalizeResponse, Error>({
    queryKey: [apiRoutes.ahafood.store.get_personalize, params],
    queryFn: () => getPersonalizeFn(params),
    ...opts,
  });
};
